// extracted by mini-css-extract-plugin
module.exports = {"title":"_ec0657","pagination":"_635001"};